import React, { Fragment, useState } from "react";
import TextField from "@mui/material/TextField";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { InputAdornment, IconButton } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useSearchParams } from "react-router-dom";

import { Typography } from "@material-ui/core";



import { Button } from "@mui/material";
import { serialize } from "swr/_internal";


export default function ResetPassword() {
  const [searchParams, setSearchParams] = useSearchParams();
  const id = searchParams.get("id")
  const [message, setMessage] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const handleClickShowConfirmPassword = () => setShowConfirmPassword(!showConfirmPassword);
  const handleMouseDownConfirmPassword = () => setShowConfirmPassword(!showConfirmPassword);



  //console.log(searchParams.get("id"));

  //handle submit
  function handleSubmit() {
    if (password !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }
    //const password = document.getElementById("password").value;
    //send data to server
    //console.log("email: " + email + " password: " + password);
    //post data to server
    const data = {
      password: password,
      id: id
    };

    console.log(JSON.stringify({ id: data.id, password: data.password }));
    fetch("/user/updatepassword", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      //body: JSON.stringify({ email: id, password: password }),
      body: JSON.stringify({ userId: id, newPassword: password }),
    })
      .then((response) => response.json())
      .then((data) => {
        //  debugger;
        console.log(data);
        //if login is successful, redirect to dasboard page

        if (data.length > 0) {
          //go to dashboard
          alert("Password updated successfully. Please login again.");

        }
        else {
          //show error message
          alert("Invalid email or password");
        }
      });

    // fetch("/user/updatepassword", {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //   },
    //   body: JSON.stringify({ id: data.id, password: data.password }),
    // })
    //   .then((response) => response.json())
    //   .then((data) => {
    //     //  debugger;
    //     console.log(data);
    //     //if login is successful, redirect to dasboard page

    //     if (data.length > 0) {
    //       // //go to dashboard
    //       // localStorage.setItem("userToken", 'Bearer ' + data);
    //       // window.location.href = "/dashboard";

    //     }
    //     else {
    //       //show error message
    //       alert("Invalid email or password");
    //     }
    //   });

  };
  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);

    const hasMinLength = newPassword.length >= 8;
    const hasUpperCase = /[A-Z]/.test(newPassword);
    const hasLowerCase = /[a-z]/.test(newPassword);
    const hasNumber = /[0-9]/.test(newPassword);
    const hasSpecialChar = /[!@#$%^&*]/.test(newPassword);

    setIsValid(hasMinLength && hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar);
  };

  const checkPasswordMatch = (e) => {
    const confirmPassword = e.target.value;
    setConfirmPassword(confirmPassword);
    if (password !== confirmPassword) {
      setMessage("Passwords do not match");
      return false;
    }
    else {
      setMessage("");
    }
    return true;
  }
  return (

    <Fragment>
      <h2>Reset Password</h2>
      <form>
        <Grid container spacing={1}>



          <Grid item xs={4} sm={4}>
            <TextField
              id="password"
              label="New Password"
              variant="outlined"
              type={showPassword ? "text" : "password"} 
              value={password}
              fullWidth
              required
              onChange={handlePasswordChange}
              InputProps={{ // <-- This is where the toggle button is added.
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
          </Grid>
          <Grid item xs={4} sm={4}>
            <TextField
              id="confirmPassword"
              label="Confirm Password"
              variant="outlined"
              type={showConfirmPassword ? "text" : "password"} 
              value={confirmPassword}
              fullWidth
              required
              onChange={checkPasswordMatch}
              InputProps={{ // <-- This is where the toggle button is added.
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowConfirmPassword}
                      onMouseDown={handleMouseDownConfirmPassword}
                    >
                      {showConfirmPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Typography variant="body2" style={{ textAlign: 'left', paddingTop: '10px', color: 'red' }} >
              {message}
              {!isValid && password.length > 0 && (
                <ul style={{ color: 'red' }}>
                  <li>Must be at least 8 characters long</li>
                  <li>Must contain an uppercase letter</li>
                  <li>Must contain a lowercase letter</li>
                  <li>Must contain a number</li>
                  <li>Must contain a special character (!@#$%^&*)</li>
                </ul>
              )}
              {isValid && password.length > 0 && (
                <p style={{ color: 'green' }}>Strong password!</p>
              )}
            </Typography>
          </Grid>
        </Grid>
        <br />

      </form>
      <Button color="primary" variant="outlined" onClick={handleSubmit}>Update Password</Button>
    </Fragment>
  );
}
